<template>
  <div
    class="mx-auto"
    :data-timestamp="event.timestamp"
  >
    <chat-notification
      :title="eventMessage"
      class="text-nowrap"
    >
      <p>{{ eventMessage }}</p>
    </chat-notification>
    <div
      v-if="isUnread"
      class="relative"
    >
      <span class="absolute right-[-10px] bottom-0 h-2 w-2 rounded-full bg-primary-tints-400" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  HistoryMessageItem,
  MessageCallFailed,
} from '@wui/im'
import { PropType, computed, toRef } from 'vue'

import { useUnreadMessages } from '@/entities/messages'

import { ChatNotification } from '@/shared/components/chat-notification'

import { getCallEventText } from '../'

const props = defineProps({
  event: {
    type: Object as PropType<HistoryMessageItem<MessageCallFailed>>,
    required: true,
  },
})

const event = toRef(props, 'event')
const eventMessage = computed<string>(() => {
  return getCallEventText(props.event)
})

const { isUnread } = useUnreadMessages(props.event)
</script>
